<template>
  <section>
    <div :class="[$mq.phone ? 'bg-white' : 'bg-gray']">
      <section class="container px-1 py-2 p-lg-3">
        <div class="row">
          <div class="col-12 p-0">

            <!-- Booking Step1: Pick date and time -->
            <booking v-if="currentStep === 1"/>

            <!-- Booking Step4: Checkout -->
            <checkout v-if="currentStep === 2"/>

          </div>
        </div>
      </section>
    </div>
    <template v-if="currentStep === 1 && !isLineLoggedIn">
      <booking-detail v-if="parentServiceId === 1"/>
      <ironing-service-detail v-if="parentServiceId === 2"/>
      <massage-service-detail v-if="parentServiceId === 7"/>
      <bathroom-cleaning-service-detail v-if="parentServiceId === 39"/>
      <service-detail v-if="parentServiceId === 35"/>
      
      <!-- Service detail html -->
      <div class="row" v-else-if="parentServiceId != 1 && parentService && parentService.has_service_items === 1">
        <div class="col-12 col-sm-8 offset-sm-2 col-lg-6 offset-lg-3 p-0">
          <div class="card">
            <div class="card-body">
              <div v-html="($i18n.locale === 'th') ? parentService.detail_th : parentService.detail_en"></div>
            </div>
          </div>
        </div>
      </div>

    </template>
  </section>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import { SweetModal } from 'sweet-modal-vue'
  import Booking from './Booking'
  import BookingDetail from '../components/BookingDetail'
  import Checkout from './Checkout'
  import IroningServiceDetail from '../components/IroningServiceDetail'
  import MassageServiceDetail from '../components/MassageServiceDetail'
  import BathroomCleaningServiceDetail from '../components/BathroomCleaningServiceDetail'
  import ServiceDetail from '../components/ServiceDetail'
  
  export default {
    components: {
      Booking,
      BookingDetail,
      Checkout,
      IroningServiceDetail,
      MassageServiceDetail,
      BathroomCleaningServiceDetail,
      ServiceDetail,
      SweetModal
    },
    data () {
      return {
        currentStep: 1,
        displayBookingInfo: false,
        parentServiceId: 1,
        parentService: null
      }
    },
    computed: {
      ...mapState('auth', ['isLineLoggedIn']),
      ...mapGetters({
        globalState: 'globalVal/getState',
        state: 'booking/getState',
        user: 'auth/getUser'
      })
    },
    watch: {
      $route (to, from) {
        this.checkCurrentStep()
      }
    },
    methods: {
      checkCurrentStep () {
        if (this.$route.query.step) {
          this.currentStep = Number(this.$route.query.step)
        } else {
          this.currentStep = 1
        }
      },
      checkLogin () {
        if (('isLoggingIn' in window.localStorage && window.localStorage.getItem('isLoggingIn') === 'false')) {
          if (this.user === null) {
            this.$parent.$parent.openModal('login')
          }
        } else {
          this.$parent.$parent.openModal('login')
        }
      }
    },
    mounted () {
      this.checkCurrentStep()
      if (typeof this.$route.query.sid === 'undefined') {
        this.parentServiceId = 1
      } else {
        this.parentServiceId = Number(this.$route.query.sid)
      }
      this.parentService = this.globalState.services[this.parentServiceId]
    }
  }
</script>

<style scoped>
  div >>> ul {
    padding-left: 1.2rem;
  }
  div >>> ol {
    padding-left: 1.2rem;
  }
</style>


// WEBPACK FOOTER //
// src/components/booking/newSteps/Index.vue